import { reducers, getState } from 'redux/core'
import { array, mixpanel } from 'common/helpers'
import { getCookieValue } from 'helpers'
import actions from 'redux/actions'


const set = (items, { shuffle = false } = {}) =>
  Promise.resolve(items)
    .then((data) => {
      let dataForStore = shuffle ? array.shuffle(data) : data

      reducers.models.stories.setNormalizeStories(dataForStore)

      return data
    })

const reset = () => {
  reducers.models.stories.reset()
}

const loadViewed = (cookieName) => {
  const value = getCookieValue(cookieName, true)
  if (value) {
    Object.keys(value).forEach((itemId) => {
      reducers.models.stories.setItemAsViewed(itemId)
      reducers.models.stories.setItemAsFinished(itemId)
    })
  }
}

const saveViewed = (cookieName) => {
  const { models: { stories: { items } } } = getState()
  const viewed = {}

  Object.keys(items).forEach((storyId) => {
    const story = items[storyId]
    if (story.isFinished) {
      viewed[storyId] = story.isFinished
    }
  })

  actions.misc.cookies.setItem(cookieName, viewed)
}

const toggleShow = () => {
  reducers.models.stories.toggleStories()
}

const setActiveItem = (item) => {
  reducers.models.stories.setActiveItem(item.id)
  reducers.models.stories.setItemAsViewed(item.id)
}

const finishItem = (item) => {
  if (!item.isFinished) {
    reducers.models.stories.setItemAsFinished(item.id)
  }
}

const trackStorySlideView = (itemId, slideIndex) => {
  reducers.models.stories.updateItem({
    id: itemId,
    lastViewedSlide: slideIndex,
  })
}

const selectItem = (item) => {
  reducers.models.stories.setSelectedItem(item)
  reducers.models.stories.toggleItemSelect(item.id)
}


export default {
  set,
  reset,
  loadViewed,
  saveViewed,
  toggleShow,
  setActiveItem,
  selectItem,
  finishItem,
  trackStorySlideView,
}
